import React ,{Fragment} from 'react';
import {BrowserRouter, Routes, Route, Outlet, useLocation, Navigate} from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import "./assets/vendor/switcher/switcher.css";
import './assets/css/style.css';
// import './assets/css/skin/skin-1.css';

//Layout
import Header from './components/Header';
import Footer from './components/Footer';
//pages
import Home from './pages/Home';
import CompanyPosts from './pages/CompanyPosts';
import AboutUs from './pages/AboutUs';
import JobsGrid from './pages/JobsGrid';
import JobDetails from './pages/JobDetails';
import Pricing from './pages/Pricing';
import BlogGrid from './pages/BlogGrid';
import BlogList from './pages/BlogList';
import BlogDetails from './pages/BlogDetails';
import ContactUs from './pages/ContactUs';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import ScrollToTop from './components/ScrollToTop';
import SubscriptionPage from '../components/SubscriptionPage';
import Switcher from './components/Switcher';
import AnimatedCursor from './components/AnimatedCursor';
import AutoLogoutWarning from './components/AutoLogoutWarning';

let basename = "";
function App() {
    const location = useLocation();
    
    // Pages où le détecteur d'inactivité doit être désactivé
    const authPages = ['/login', '/register', '/users/verify/email/'];
    const isAuthPage = authPages.some(page => location.pathname.startsWith(page));
    
    // Vérification de sécurité pour reCAPTCHA
    // IMPORTANT: Remplacez cette clé par votre propre clé reCAPTCHA v3
    // Obtenez une clé sur: https://www.google.com/recaptcha/admin
    const recaptchaKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LcXS9ElAAAAAFSeQtM-5c9jKmCpRL8Z-xEOJ9dO";
    
    // Gestion des erreurs reCAPTCHA
    React.useEffect(() => {
        const handleRecaptchaError = (event) => {
            // Intercepter les erreurs reCAPTCHA
            if (event.error && event.error.message) {
                const errorMsg = event.error.message.toLowerCase();
                if (errorMsg.includes('recaptcha') || errorMsg.includes('logging') || errorMsg.includes('sitekey')) {
                    console.warn('reCAPTCHA error intercepted and suppressed:', event.error.message);
                    event.preventDefault();
                    event.stopPropagation();
                    return true;
                }
            }
            // Pour les rejections de promesses
            if (event.reason && event.reason.message) {
                const errorMsg = event.reason.message.toLowerCase();
                if (errorMsg.includes('recaptcha') || errorMsg.includes('logging') || errorMsg.includes('sitekey')) {
                    console.warn('reCAPTCHA promise rejection intercepted:', event.reason.message);
                    event.preventDefault();
                    return true;
                }
            }
        };
        
        // Intercepter les erreurs globales
        const originalErrorHandler = window.onerror;
        window.onerror = function(message, source, lineno, colno, error) {
            if (typeof message === 'string' && (message.includes('recaptcha') || message.includes('logging') || message.includes('sitekey'))) {
                console.warn('reCAPTCHA error suppressed:', message);
                return true; // Empêche la propagation
            }
            if (originalErrorHandler) {
                return originalErrorHandler(message, source, lineno, colno, error);
            }
            return false;
        };
        
        window.addEventListener('error', handleRecaptchaError, true);
        window.addEventListener('unhandledrejection', handleRecaptchaError, true);
        
        return () => {
            window.removeEventListener('error', handleRecaptchaError, true);
            window.removeEventListener('unhandledrejection', handleRecaptchaError, true);
            window.onerror = originalErrorHandler;
        };
    }, []);
    
    return (
      <Fragment>
        <GoogleReCaptchaProvider 
          reCaptchaKey={recaptchaKey}
          language="fr"
          useRecaptchaNet={false}
          scriptProps={{
            async: true,
            defer: true,
            appendTo: "head",
            nonce: undefined,
          }}
        >
          <div>
            <Routes >			
				<Route element= {<Layouts/>} >
					<Route path="/" element = {<Home />} />
					<Route path="/about-us" element = {<AboutUs />} />
					{/* Public offers listing */}
                    <Route path="/posts" element = {<JobsGrid />} />
                    {/* Backward compatibility: redirect old /jobs-grid to /posts */}
                    <Route path="/jobs-grid" element = {<Navigate replace to="/posts" />} />
                    {/* Company posts listing */}
                    <Route path="/companies/:id/posts" element={<CompanyPosts />} />
					<Route path="/job-detail" element = {<JobDetails />} />
					<Route path="/pricing" element = {<Pricing />} />
					<Route path="/blog-grid" element = {<BlogGrid />} />
					<Route path="/blog-list" element = {<BlogList />} />
					<Route path="/blog-details" element = {<BlogDetails />} />
					<Route path="/contact-us" element = {<ContactUs />} />
					<Route path="/contact" element = {<ContactUs />} />
					<Route path="/register" element = {<Register />} />
					<Route path="/users/verify/email/:token" element = {<VerifyEmail />} />
					<Route path="/subscription" element = {<SubscriptionPage />} />
				</Route>	
            </Routes>
		    <AnimatedCursor />
		    <Switcher />
		    <ScrollToTop />
		    <AutoLogoutWarning enabled={!isAuthPage} />
		  </div>
        </GoogleReCaptchaProvider>
      </Fragment>
    );
}

function Layouts(){
    const location = useLocation();
    const transparentRoutes = ['/contact-us', '/contact', '/pricing', '/about-us'];
    const headerStyle = transparentRoutes.includes(location.pathname) ? 'header-transparent' : '';
    return(
        <>
            <div className='page-wraper'>
                <Header style={headerStyle}/>
                <Outlet />
                <Footer />
            </div>            
        </>
    )
}

export default App;
